import type { RecipeDefinition } from "./types";

export const recipes: RecipeDefinition[] = [
  {
    id: "toast",
    name: "Butter Toast",
    category: "appetizer",
    ingredients: ["bread", "butter"],
    preparationTimeSeconds: 3,
    stationNeeded: "counter",
    appliances: ["toaster"],
    sellPrice: 18,
    satisfactionEffect: 4,
    unlockedByDefault: true,
  },
  {
    id: "garden-salad",
    name: "Garden Salad",
    category: "appetizer",
    ingredients: ["lettuce", "tomato", "oil"],
    preparationTimeSeconds: 4,
    stationNeeded: "counter",
    sellPrice: 24,
    satisfactionEffect: 5,
    unlockedByDefault: true,
    activeByDefault: true,
  },
  {
    id: "bruschetta",
    name: "Bruschetta",
    category: "appetizer",
    ingredients: ["bread", "tomato", "herbs"],
    preparationTimeSeconds: 4,
    stationNeeded: "counter",
    appliances: ["toaster"],
    sellPrice: 25,
    satisfactionEffect: 5,
    unlockedByDefault: true,
  },
  {
    id: "stuffed-mushrooms",
    name: "Stuffed Mushrooms",
    category: "appetizer",
    ingredients: ["mushroom", "cheese", "herbs"],
    preparationTimeSeconds: 6,
    stationNeeded: "stove",
    appliances: ["stove", "counter"],
    sellPrice: 32,
    satisfactionEffect: 7,
    unlockedByDefault: true,
  },
  {
    id: "spring-rolls",
    name: "Spring Rolls",
    category: "appetizer",
    ingredients: ["vegetables", "oil", "flour"],
    preparationTimeSeconds: 7,
    stationNeeded: "stove",
    sellPrice: 34,
    satisfactionEffect: 7,
    unlockedByDefault: true,
    activeByDefault: true,
  },
  {
    id: "soup",
    name: "Herb Soup",
    category: "appetizer",
    ingredients: ["stock", "vegetables", "herbs"],
    preparationTimeSeconds: 6,
    stationNeeded: "stove",
    appliances: ["stove", "blender"],
    sellPrice: 30,
    satisfactionEffect: 7,
    unlockedByDefault: true,
  },
  {
    id: "pasta",
    name: "Tomato Pasta",
    category: "main",
    ingredients: ["pasta", "tomato", "cheese"],
    preparationTimeSeconds: 9,
    stationNeeded: "stove",
    sellPrice: 44,
    satisfactionEffect: 10,
    unlockedByDefault: true,
    activeByDefault: true,
  },
  {
    id: "chicken-rice",
    name: "Chicken Rice",
    category: "main",
    ingredients: ["chicken", "rice", "stock"],
    preparationTimeSeconds: 10,
    stationNeeded: "stove",
    sellPrice: 48,
    satisfactionEffect: 11,
    unlockedByDefault: true,
  },
  {
    id: "veggie-curry",
    name: "Veggie Curry",
    category: "main",
    ingredients: ["vegetables", "rice", "spices"],
    preparationTimeSeconds: 11,
    stationNeeded: "stove",
    appliances: ["stove", "blender"],
    sellPrice: 46,
    satisfactionEffect: 10,
    unlockedByDefault: true,
  },
  {
    id: "beef-stew",
    name: "Beef Stew",
    category: "main",
    ingredients: ["beef", "potato", "stock"],
    preparationTimeSeconds: 12,
    stationNeeded: "stove",
    sellPrice: 56,
    satisfactionEffect: 13,
    unlockedByDefault: true,
  },
  {
    id: "fish-tacos",
    name: "Fish Tacos",
    category: "main",
    ingredients: ["fish", "flour", "lettuce"],
    preparationTimeSeconds: 9,
    stationNeeded: "stove",
    sellPrice: 50,
    satisfactionEffect: 11,
    unlockedByDefault: true,
  },
  {
    id: "mushroom-risotto",
    name: "Mushroom Risotto",
    category: "main",
    ingredients: ["mushroom", "rice", "cheese"],
    preparationTimeSeconds: 11,
    stationNeeded: "stove",
    sellPrice: 52,
    satisfactionEffect: 12,
    unlockedByDefault: true,
  },
  {
    id: "cheese-omelet",
    name: "Cheese Omelet",
    category: "main",
    ingredients: ["egg", "cheese", "butter"],
    preparationTimeSeconds: 7,
    stationNeeded: "stove",
    sellPrice: 38,
    satisfactionEffect: 8,
    unlockedByDefault: true,
  },
  {
    id: "pancakes",
    name: "Pancakes",
    category: "dessert",
    ingredients: ["flour", "egg", "sugar"],
    preparationTimeSeconds: 7,
    stationNeeded: "stove",
    appliances: ["stove", "blender"],
    sellPrice: 36,
    satisfactionEffect: 9,
    unlockedByDefault: true,
  },
  {
    id: "berry-tart",
    name: "Berry Tart",
    category: "dessert",
    ingredients: ["berries", "flour", "sugar"],
    preparationTimeSeconds: 9,
    stationNeeded: "counter",
    appliances: ["counter", "stove"],
    sellPrice: 42,
    satisfactionEffect: 11,
    unlockedByDefault: true,
  },
  {
    id: "chocolate-cake",
    name: "Chocolate Cake",
    category: "dessert",
    ingredients: ["cocoa", "flour", "sugar"],
    preparationTimeSeconds: 10,
    stationNeeded: "counter",
    appliances: ["counter", "stove", "microwave"],
    sellPrice: 48,
    satisfactionEffect: 13,
    unlockedByDefault: true,
  },
  {
    id: "ice-cream",
    name: "Vanilla Ice Cream",
    category: "dessert",
    ingredients: ["milk", "sugar", "cream"],
    preparationTimeSeconds: 5,
    stationNeeded: "counter",
    appliances: ["counter", "blender"],
    sellPrice: 34,
    satisfactionEffect: 8,
    unlockedByDefault: true,
  },
  {
    id: "apple-pie",
    name: "Apple Pie",
    category: "dessert",
    ingredients: ["apple", "flour", "sugar"],
    preparationTimeSeconds: 11,
    stationNeeded: "counter",
    appliances: ["counter", "stove"],
    sellPrice: 46,
    satisfactionEffect: 12,
    unlockedByDefault: true,
  },
  {
    id: "lemonade",
    name: "Lemonade",
    category: "drink",
    ingredients: ["lemon", "sugar"],
    preparationTimeSeconds: 3,
    stationNeeded: "counter",
    appliances: ["counter", "blender"],
    sellPrice: 18,
    satisfactionEffect: 4,
    unlockedByDefault: true,
  },
  {
    id: "iced-tea",
    name: "Iced Tea",
    category: "drink",
    ingredients: ["tea", "sugar"],
    preparationTimeSeconds: 3,
    stationNeeded: "counter",
    sellPrice: 18,
    satisfactionEffect: 4,
    unlockedByDefault: true,
    activeByDefault: true,
  },
  {
    id: "coffee",
    name: "Cozy Coffee",
    category: "drink",
    ingredients: ["coffee", "milk"],
    preparationTimeSeconds: 4,
    stationNeeded: "counter",
    appliances: ["coffee"],
    sellPrice: 22,
    satisfactionEffect: 5,
    unlockedByDefault: true,
  },
  {
    id: "berry-smoothie",
    name: "Berry Smoothie",
    category: "drink",
    ingredients: ["berries", "milk", "sugar"],
    preparationTimeSeconds: 4,
    stationNeeded: "counter",
    appliances: ["blender"],
    sellPrice: 28,
    satisfactionEffect: 7,
    unlockedByDefault: true,
  },
  {
    id: "orange-juice",
    name: "Orange Juice",
    category: "drink",
    ingredients: ["orange", "sugar"],
    preparationTimeSeconds: 3,
    stationNeeded: "counter",
    appliances: ["counter", "blender"],
    sellPrice: 20,
    satisfactionEffect: 5,
    unlockedByDefault: true,
  },
  {
    id: "garlic-bread",
    name: "Garlic Bread",
    category: "side",
    ingredients: ["bread", "butter", "herbs"],
    preparationTimeSeconds: 5,
    stationNeeded: "stove",
    appliances: ["stove", "toaster"],
    sellPrice: 24,
    satisfactionEffect: 6,
    unlockedByDefault: true,
  },
  {
    id: "fries",
    name: "Crispy Fries",
    category: "side",
    ingredients: ["potato", "oil", "salt"],
    preparationTimeSeconds: 6,
    stationNeeded: "stove",
    sellPrice: 26,
    satisfactionEffect: 6,
    unlockedByDefault: true,
  },
  {
    id: "rice-bowl",
    name: "Rice Bowl",
    category: "side",
    ingredients: ["rice", "herbs"],
    preparationTimeSeconds: 5,
    stationNeeded: "stove",
    sellPrice: 24,
    satisfactionEffect: 5,
    unlockedByDefault: true,
    activeByDefault: true,
  },
  {
    id: "roasted-veg",
    name: "Roasted Veg",
    category: "side",
    ingredients: ["vegetables", "oil", "salt"],
    preparationTimeSeconds: 7,
    stationNeeded: "stove",
    sellPrice: 30,
    satisfactionEffect: 7,
    unlockedByDefault: true,
  },
  {
    id: "cheese-plate",
    name: "Cheese Plate",
    category: "side",
    ingredients: ["cheese", "bread", "apple"],
    preparationTimeSeconds: 4,
    stationNeeded: "counter",
    sellPrice: 34,
    satisfactionEffect: 8,
    unlockedByDefault: true,
  },
  {
    id: "house-pickles",
    name: "House Pickles",
    category: "appetizer",
    luxuryTier: 1,
    ingredients: ["vegetables", "salt"],
    preparationTimeSeconds: 3,
    stationNeeded: "counter",
    sellPrice: 20,
    satisfactionEffect: 3,
    unlockedByDefault: true,
  },
  {
    id: "tomato-skewers",
    name: "Tomato Skewers",
    category: "appetizer",
    luxuryTier: 2,
    ingredients: ["tomato", "cheese", "herbs"],
    preparationTimeSeconds: 4,
    stationNeeded: "counter",
    appliances: ["counter", "stove"],
    sellPrice: 42,
    satisfactionEffect: 8,
    unlockedByDefault: false,
  },
  {
    id: "pumpkin-crostini",
    name: "Pumpkin Crostini",
    category: "appetizer",
    luxuryTier: 3,
    ingredients: ["bread", "pumpkin", "cheese"],
    preparationTimeSeconds: 6,
    stationNeeded: "stove",
    appliances: ["stove", "toaster"],
    sellPrice: 60,
    satisfactionEffect: 11,
    unlockedByDefault: false,
  },
  {
    id: "shrimp-cups",
    name: "Shrimp Cups",
    category: "appetizer",
    luxuryTier: 4,
    ingredients: ["shrimp", "lettuce", "lemon"],
    preparationTimeSeconds: 6,
    stationNeeded: "counter",
    appliances: ["counter", "stove"],
    sellPrice: 78,
    satisfactionEffect: 15,
    unlockedByDefault: false,
  },
  {
    id: "truffle-bites",
    name: "Truffle Bites",
    category: "appetizer",
    luxuryTier: 5,
    ingredients: ["truffle", "mushroom", "cream"],
    preparationTimeSeconds: 8,
    stationNeeded: "stove",
    appliances: ["stove", "counter"],
    sellPrice: 112,
    satisfactionEffect: 22,
    unlockedByDefault: false,
  },
  {
    id: "lentil-bowl",
    name: "Lentil Bowl",
    category: "main",
    luxuryTier: 1,
    ingredients: ["lentils", "stock", "herbs"],
    preparationTimeSeconds: 8,
    stationNeeded: "stove",
    sellPrice: 35,
    satisfactionEffect: 7,
    unlockedByDefault: true,
    activeByDefault: true,
  },
  {
    id: "grilled-cheese",
    name: "Grilled Cheese",
    category: "main",
    luxuryTier: 1,
    ingredients: ["bread", "cheese", "butter"],
    preparationTimeSeconds: 5,
    stationNeeded: "stove",
    sellPrice: 30,
    satisfactionEffect: 6,
    unlockedByDefault: true,
  },
  {
    id: "mac-and-cheese",
    name: "Mac & Cheese",
    category: "main",
    luxuryTier: 1,
    ingredients: ["pasta", "cheese", "milk"],
    preparationTimeSeconds: 6,
    stationNeeded: "stove",
    sellPrice: 33,
    satisfactionEffect: 6,
    unlockedByDefault: true,
  },
  {
    id: "veggie-stir-fry",
    name: "Veggie Stir-fry",
    category: "main",
    luxuryTier: 1,
    ingredients: ["vegetables", "rice", "oil"],
    preparationTimeSeconds: 6,
    stationNeeded: "stove",
    sellPrice: 31,
    satisfactionEffect: 5,
    unlockedByDefault: true,
  },
  {
    id: "turkey-sandwich",
    name: "Turkey Sandwich",
    category: "main",
    luxuryTier: 2,
    ingredients: ["bread", "turkey", "lettuce"],
    preparationTimeSeconds: 5,
    stationNeeded: "counter",
    appliances: ["counter", "toaster"],
    sellPrice: 50,
    satisfactionEffect: 9,
    unlockedByDefault: false,
  },
  {
    id: "salmon-noodles",
    name: "Salmon Noodles",
    category: "main",
    luxuryTier: 3,
    ingredients: ["salmon", "pasta", "lemon"],
    preparationTimeSeconds: 10,
    stationNeeded: "stove",
    sellPrice: 72,
    satisfactionEffect: 16,
    unlockedByDefault: false,
  },
  {
    id: "duck-polenta",
    name: "Duck Polenta",
    category: "main",
    luxuryTier: 4,
    ingredients: ["duck", "corn", "butter"],
    preparationTimeSeconds: 13,
    stationNeeded: "stove",
    sellPrice: 96,
    satisfactionEffect: 21,
    unlockedByDefault: false,
  },
  {
    id: "filet-mignon",
    name: "Filet Mignon",
    category: "main",
    luxuryTier: 5,
    ingredients: ["filet", "truffle", "butter"],
    preparationTimeSeconds: 14,
    stationNeeded: "stove",
    sellPrice: 140,
    satisfactionEffect: 30,
    unlockedByDefault: false,
  },
  {
    id: "honey-yogurt",
    name: "Honey Yogurt",
    category: "dessert",
    luxuryTier: 1,
    ingredients: ["yogurt", "honey"],
    preparationTimeSeconds: 3,
    stationNeeded: "counter",
    sellPrice: 25,
    satisfactionEffect: 5,
    unlockedByDefault: true,
    activeByDefault: true,
  },
  {
    id: "fruit-cup",
    name: "Fruit Cup",
    category: "dessert",
    luxuryTier: 1,
    ingredients: ["berries", "apple", "honey"],
    preparationTimeSeconds: 3,
    stationNeeded: "counter",
    sellPrice: 24,
    satisfactionEffect: 5,
    unlockedByDefault: true,
  },
  {
    id: "chocolate-pudding",
    name: "Chocolate Pudding",
    category: "dessert",
    luxuryTier: 1,
    ingredients: ["milk", "cocoa", "sugar"],
    preparationTimeSeconds: 5,
    stationNeeded: "stove",
    sellPrice: 26,
    satisfactionEffect: 6,
    unlockedByDefault: true,
  },
  {
    id: "carrot-cake",
    name: "Carrot Cake",
    category: "dessert",
    luxuryTier: 2,
    ingredients: ["carrot", "flour", "sugar"],
    preparationTimeSeconds: 8,
    stationNeeded: "counter",
    appliances: ["counter", "stove"],
    sellPrice: 50,
    satisfactionEffect: 11,
    unlockedByDefault: false,
  },
  {
    id: "pear-galette",
    name: "Pear Galette",
    category: "dessert",
    luxuryTier: 3,
    ingredients: ["pear", "flour", "butter"],
    preparationTimeSeconds: 10,
    stationNeeded: "counter",
    appliances: ["counter", "stove"],
    sellPrice: 65,
    satisfactionEffect: 14,
    unlockedByDefault: false,
  },
  {
    id: "pistachio-cream",
    name: "Pistachio Cream",
    category: "dessert",
    luxuryTier: 4,
    ingredients: ["pistachio", "cream", "sugar"],
    preparationTimeSeconds: 8,
    stationNeeded: "counter",
    appliances: ["counter", "blender"],
    sellPrice: 78,
    satisfactionEffect: 18,
    unlockedByDefault: false,
  },
  {
    id: "golden-souffle",
    name: "Golden Souffle",
    category: "dessert",
    luxuryTier: 5,
    ingredients: ["egg", "vanilla", "cream"],
    preparationTimeSeconds: 13,
    stationNeeded: "stove",
    appliances: ["stove", "blender"],
    sellPrice: 118,
    satisfactionEffect: 26,
    unlockedByDefault: false,
  },
  {
    id: "mint-water",
    name: "Mint Water",
    category: "drink",
    luxuryTier: 1,
    ingredients: ["mint", "lemon"],
    preparationTimeSeconds: 2,
    stationNeeded: "counter",
    sellPrice: 18,
    satisfactionEffect: 3,
    unlockedByDefault: true,
  },
  {
    id: "spiced-cocoa",
    name: "Spiced Cocoa",
    category: "drink",
    luxuryTier: 2,
    ingredients: ["cocoa", "milk", "spices"],
    preparationTimeSeconds: 4,
    stationNeeded: "counter",
    appliances: ["coffee"],
    sellPrice: 42,
    satisfactionEffect: 8,
    unlockedByDefault: false,
  },
  {
    id: "matcha-latte",
    name: "Matcha Latte",
    category: "drink",
    luxuryTier: 3,
    ingredients: ["matcha", "milk", "sugar"],
    preparationTimeSeconds: 4,
    stationNeeded: "counter",
    appliances: ["coffee", "blender"],
    sellPrice: 60,
    satisfactionEffect: 10,
    unlockedByDefault: false,
  },
  {
    id: "rose-spritz",
    name: "Rose Spritz",
    category: "drink",
    luxuryTier: 4,
    ingredients: ["rose", "orange", "sugar"],
    preparationTimeSeconds: 5,
    stationNeeded: "counter",
    sellPrice: 76,
    satisfactionEffect: 14,
    unlockedByDefault: false,
  },
  {
    id: "saffron-tea",
    name: "Saffron Tea",
    category: "drink",
    luxuryTier: 5,
    ingredients: ["saffron", "tea", "honey"],
    preparationTimeSeconds: 5,
    stationNeeded: "counter",
    appliances: ["coffee"],
    sellPrice: 102,
    satisfactionEffect: 20,
    unlockedByDefault: false,
  },
  {
    id: "buttered-corn",
    name: "Buttered Corn",
    category: "side",
    luxuryTier: 1,
    ingredients: ["corn", "butter"],
    preparationTimeSeconds: 4,
    stationNeeded: "stove",
    sellPrice: 25,
    satisfactionEffect: 4,
    unlockedByDefault: true,
  },
  {
    id: "sweet-potatoes",
    name: "Sweet Potatoes",
    category: "side",
    luxuryTier: 2,
    ingredients: ["sweet-potato", "oil", "salt"],
    preparationTimeSeconds: 7,
    stationNeeded: "stove",
    sellPrice: 45,
    satisfactionEffect: 8,
    unlockedByDefault: false,
  },
  {
    id: "goat-cheese-toast",
    name: "Goat Cheese Toast",
    category: "side",
    luxuryTier: 3,
    ingredients: ["bread", "goat-cheese", "honey"],
    preparationTimeSeconds: 5,
    stationNeeded: "counter",
    appliances: ["toaster"],
    sellPrice: 60,
    satisfactionEffect: 13,
    unlockedByDefault: false,
  },
  {
    id: "asparagus-gratin",
    name: "Asparagus Gratin",
    category: "side",
    luxuryTier: 4,
    ingredients: ["asparagus", "cream", "cheese"],
    preparationTimeSeconds: 9,
    stationNeeded: "stove",
    sellPrice: 78,
    satisfactionEffect: 16,
    unlockedByDefault: false,
  },
  {
    id: "caviar-toast",
    name: "Caviar Toast",
    category: "side",
    luxuryTier: 5,
    ingredients: ["caviar", "bread", "butter"],
    preparationTimeSeconds: 5,
    stationNeeded: "counter",
    appliances: ["toaster"],
    sellPrice: 120,
    satisfactionEffect: 24,
    unlockedByDefault: false,
  },

  // === GRILL dishes (need a Flat-Top Grill). Smoky grilled mains. ===
  {
    id: "beef-skewers",
    name: "Beef Skewers",
    category: "main",
    luxuryTier: 2,
    ingredients: ["beef", "vegetables", "spices"],
    preparationTimeSeconds: 7,
    stationNeeded: "stove",
    appliances: ["grill"],
    sellPrice: 42,
    satisfactionEffect: 9,
    unlockedByDefault: false,
  },
  {
    id: "smash-burger",
    name: "Smash Burger",
    category: "main",
    luxuryTier: 2,
    ingredients: ["bun", "beef", "cheese"],
    preparationTimeSeconds: 6,
    stationNeeded: "stove",
    appliances: ["grill"],
    sellPrice: 38,
    satisfactionEffect: 9,
    unlockedByDefault: false,
  },
  {
    id: "grilled-salmon",
    name: "Grilled Salmon",
    category: "main",
    luxuryTier: 4,
    ingredients: ["salmon", "lemon", "herbs"],
    preparationTimeSeconds: 9,
    stationNeeded: "stove",
    appliances: ["grill"],
    sellPrice: 88,
    satisfactionEffect: 17,
    unlockedByDefault: false,
  },
  {
    id: "bbq-ribs",
    name: "BBQ Ribs",
    category: "main",
    luxuryTier: 4,
    ingredients: ["ribs", "bbq-sauce", "spices"],
    preparationTimeSeconds: 12,
    stationNeeded: "stove",
    appliances: ["grill"],
    sellPrice: 96,
    satisfactionEffect: 18,
    unlockedByDefault: false,
  },

  // === FRYER dishes (need a Deep Fryer). Crispy sides + apps. ===
  {
    id: "french-fries",
    name: "French Fries",
    category: "side",
    luxuryTier: 2,
    ingredients: ["potato", "oil", "salt"],
    preparationTimeSeconds: 4,
    stationNeeded: "stove",
    appliances: ["fryer"],
    sellPrice: 20,
    satisfactionEffect: 5,
    unlockedByDefault: false,
  },
  {
    id: "onion-rings",
    name: "Onion Rings",
    category: "side",
    luxuryTier: 2,
    ingredients: ["onion", "flour", "oil"],
    preparationTimeSeconds: 4,
    stationNeeded: "stove",
    appliances: ["fryer"],
    sellPrice: 22,
    satisfactionEffect: 5,
    unlockedByDefault: false,
  },
  {
    id: "calamari",
    name: "Fried Calamari",
    category: "appetizer",
    luxuryTier: 3,
    ingredients: ["squid", "flour", "lemon"],
    preparationTimeSeconds: 6,
    stationNeeded: "stove",
    appliances: ["fryer"],
    sellPrice: 58,
    satisfactionEffect: 12,
    unlockedByDefault: false,
  },
  {
    id: "fried-chicken",
    name: "Fried Chicken",
    category: "main",
    luxuryTier: 3,
    ingredients: ["chicken", "flour", "spices"],
    preparationTimeSeconds: 8,
    stationNeeded: "stove",
    appliances: ["fryer"],
    sellPrice: 62,
    satisfactionEffect: 13,
    unlockedByDefault: false,
  },
  {
    id: "tempura",
    name: "Shrimp Tempura",
    category: "appetizer",
    luxuryTier: 4,
    ingredients: ["shrimp", "vegetables", "flour"],
    preparationTimeSeconds: 7,
    stationNeeded: "stove",
    appliances: ["fryer"],
    sellPrice: 82,
    satisfactionEffect: 16,
    unlockedByDefault: false,
  },

  // === OVEN dishes (need a Convection Oven). Baked mains + desserts. ===
  {
    id: "roast-chicken",
    name: "Roast Chicken",
    category: "main",
    luxuryTier: 3,
    ingredients: ["chicken", "herbs", "potato"],
    preparationTimeSeconds: 10,
    stationNeeded: "stove",
    appliances: ["oven"],
    sellPrice: 65,
    satisfactionEffect: 14,
    unlockedByDefault: false,
  },
  {
    id: "lasagna",
    name: "Lasagna",
    category: "main",
    luxuryTier: 3,
    ingredients: ["pasta", "beef", "cheese", "tomato"],
    preparationTimeSeconds: 11,
    stationNeeded: "stove",
    appliances: ["oven"],
    sellPrice: 70,
    satisfactionEffect: 15,
    unlockedByDefault: false,
  },
  {
    id: "chocolate-cake",
    name: "Chocolate Cake",
    category: "dessert",
    luxuryTier: 2,
    ingredients: ["flour", "cocoa", "egg", "sugar"],
    preparationTimeSeconds: 8,
    stationNeeded: "stove",
    appliances: ["oven"],
    sellPrice: 36,
    satisfactionEffect: 9,
    unlockedByDefault: false,
  },
  {
    id: "apple-pie",
    name: "Apple Pie",
    category: "dessert",
    luxuryTier: 2,
    ingredients: ["apple", "flour", "butter", "sugar"],
    preparationTimeSeconds: 8,
    stationNeeded: "stove",
    appliances: ["oven"],
    sellPrice: 34,
    satisfactionEffect: 8,
    unlockedByDefault: false,
  },
  {
    id: "creme-brulee",
    name: "Crème Brûlée",
    category: "dessert",
    luxuryTier: 4,
    ingredients: ["cream", "egg", "sugar", "vanilla"],
    preparationTimeSeconds: 7,
    stationNeeded: "stove",
    appliances: ["oven"],
    sellPrice: 84,
    satisfactionEffect: 17,
    unlockedByDefault: false,
  },

  // === PIZZA OVEN dishes (need a Wood-Fired Pizza Oven). ===
  {
    id: "margherita-pizza",
    name: "Margherita Pizza",
    category: "main",
    luxuryTier: 4,
    ingredients: ["dough", "tomato", "mozzarella", "basil"],
    preparationTimeSeconds: 9,
    stationNeeded: "stove",
    appliances: ["pizza-oven"],
    sellPrice: 56,
    satisfactionEffect: 12,
    unlockedByDefault: false,
  },
  {
    id: "pepperoni-pizza",
    name: "Pepperoni Pizza",
    category: "main",
    luxuryTier: 4,
    ingredients: ["dough", "tomato", "mozzarella", "sausage"],
    preparationTimeSeconds: 9,
    stationNeeded: "stove",
    appliances: ["pizza-oven"],
    sellPrice: 62,
    satisfactionEffect: 13,
    unlockedByDefault: false,
  },
  {
    id: "truffle-pizza",
    name: "Truffle Pizza",
    category: "main",
    luxuryTier: 5,
    ingredients: ["dough", "mozzarella", "truffle", "mushroom"],
    preparationTimeSeconds: 10,
    stationNeeded: "stove",
    appliances: ["pizza-oven"],
    sellPrice: 130,
    satisfactionEffect: 24,
    unlockedByDefault: false,
  },
];
